import chalk from "chalk";
import ora from "ora";
import { checkApiKey } from "../../utils/apiKey";
import { formatFetchError } from "../../utils/formatFetchError";
import { failSpinner } from "../../utils/spinnerError";
import { buildAuthHeaders } from "@/internal/api/auth";

import { resolveControlPlaneUrl } from "@/cli/utils/governance/resolveEndpoint";
export const createGraphCommand = async (
  name: string,
  options: {
    dashboardId?: string;
    graph?: string;
    filters?: string;
    colSpan?: string;
    rowSpan?: string;
    format?: string;
  },
): Promise<void> => {
  checkApiKey();

  const apiKey = process.env.LANGWATCH_API_KEY ?? "";
  const endpoint = resolveControlPlaneUrl();

  const spinner = ora(`Creating graph "${name}"...`).start();

  try {
    let graphDef: Record<string, unknown> = {};
    if (options.graph) {
      graphDef = JSON.parse(options.graph) as Record<string, unknown>;
    }

    const response = await fetch(`${endpoint}/api/graphs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...buildAuthHeaders({ apiKey }),
      },
      body: JSON.stringify({
        name,
        graph: graphDef,
        dashboardId: options.dashboardId,
        ...(options.filters && { filters: JSON.parse(options.filters) }),
        ...(options.colSpan && { colSpan: parseInt(options.colSpan, 10) }),
        ...(options.rowSpan && { rowSpan: parseInt(options.rowSpan, 10) }),
      }),
    });

    if (!response.ok) {
      const message = await formatFetchError(response);
      spinner.fail(`Failed to create graph: ${message}`);
      process.exit(1);
    }

    const graph = await response.json() as { id: string; name: string; dashboardId: string | null };
    spinner.succeed(`Graph "${graph.name}" created (${graph.id})`);

    if (options.format === "json") {
      console.log(JSON.stringify(graph, null, 2));
      return;
    }

    console.log();
    console.log(`  ${chalk.gray("ID:")}        ${chalk.green(graph.id)}`);
    console.log(`  ${chalk.gray("Dashboard:")} ${graph.dashboardId ?? chalk.gray("—")}`);
    console.log();
  } catch (error) {
    if (error instanceof SyntaxError) {
      spinner.fail(chalk.red("--graph must be valid JSON"));
    } else {
      failSpinner({ spinner, error, action: "create graph" });
    }
    process.exit(1);
  }
};
